import { COLORS } from '@Commons';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  background-color: ${COLORS.lightShadedGrey};
  min-height: 100vh;
  font-family: inherit;
`;

export const Header = styled.div`
  background-color: ${COLORS.dividerBlue};
  height: 265px;
  display: flex;
  justify-content: center;
  padding-top: 60px;
  @media (max-width: 600px) {
    height: 160px;
    padding-top: 40px;
  }
`;

export const Card = styled.div`
  position: absolute;
  background: ${COLORS.white};
  border-radius: 16px;
  box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.1);
  width: 540px;
  height: 190px;
  top: 138px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  padding: 36px 40px;
  gap: 40px;
  @media (max-width: 600px) {
    width: 335px;
    height: 152px;
    top: 100px;
    padding: 24px;
  }
`;

export const CardCol = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Body = styled.div`
  max-width: 700px;
  margin: 0 auto;
  margin-top: 140px;
  background: ${COLORS.white};
  border-radius: 16px;
  padding: 0 24px 24px;
  @media (max-width: 768px) {
    margin-top: 100px;
  }
`;

export const TabBar = styled.div`
  display: flex;
  border-bottom: 1px solid ${COLORS.borderGrey};
  margin-bottom: 24px;
`;

export const Tab = styled.div`
  flex: 1;
  padding: 14px 0;
`;

export const InfoBox = styled.div`
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ContentCard = styled.div`
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ContentCardDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HistorySection = styled.div`
  margin-top: 24px;
`;

export const HistoryRow = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 0;
  border-top: 1px solid ${COLORS.borderGrey};
`;

export const HistoryRowMain = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
